<template>
  <v-card-text class="d-flex justify-space-between">
    <v-row>
      <v-col v-if="isConfirmationStep" class="shipping-cost" cols="12" md>
        <v-card class="px-1" style="height: 100%; display: flex; flex-direction: column">
          <h1 class="title-area text-left black--text font-weight-medium">Custo de transporte por embarques</h1>
          <div class="d-flex justify-center pt-2" style="height: 240px; flex-grow: 1; overflow-y: auto">
            <template>
              <v-simple-table
                class="table-shipping-cost"
                style="margin: 0px 10px; min-width: 400px; width: 100%; height: 150px"
                fixed-header
                :height="tableBoardingsHeight()"
                dense
              >
                <thead>
                  <tr>
                    <th class="text-left">Nº</th>
                    <th class="text-left">Motorista</th>
                    <th class="text-center">Receita Frete</th>
                    <th class="text-center">Despesa Motorista</th>
                    <th class="text-center">Despesa Transbordo</th>
                    <th class="text-center">Custo de Transporte</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(boarding, index) in boardings" :key="index">
                    <td>{{ boarding.boardingNumber }}</td>
                    <td>
                      <TruncateDataWithTooltip
                        :data="boarding.directDelivererName"
                        :lengthDataToTruncate="8"
                      ></TruncateDataWithTooltip>
                    </td>
                    <td class="text-center">{{ formatPrice(boarding.totalDeliveriesPrice) }}</td>
                    <td class="text-center">{{ formatPrice(boarding.freightPrice) }}</td>
                    <td class="text-center">{{ formatPrice(boarding.totalTranshipmentsPrice) }}</td>
                    <td class="text-center">{{ boarding.percentageShippingCost }}%</td>
                  </tr>
                </tbody>
              </v-simple-table>
            </template>
          </div>
        </v-card>
      </v-col>
      <v-col cols="12" md>
        <v-card class="px-1">
          <div class="d-flex" style="height: 30px">
            <h1 class="title-area text-left black--text font-weight-medium" style="width: 170px">
              Entregas por cidade
            </h1>
            <v-radio-group v-model="nfesByCity" row mandatory>
              <v-radio label="NFes" :value="true" class="small-radio"></v-radio>
              <v-radio label="Entregas" :value="false" class="small-radio"></v-radio>
            </v-radio-group>
          </div>
          <div class="d-flex justify-center pt-8" style="height: 240px; margin: auto; flex-grow: 1">
            <v-progress-circular v-if="loading" indeterminate color="primary" size="140"></v-progress-circular>

            <div class="d-flex mr-1 pr-4 justify-end">
              <canvas
                id="doughnutChart"
                style="max-width: 160px; max-height: 160px"
                :style="{ display: loading ? 'none' : '' }"
              ></canvas>
            </div>
            <div v-if="!loading" class="d-flex" style="height: 240px">
              <v-list class="pa-0 pr-2 deliveries-list scrollbar-list">
                <v-list-item v-for="(item, index) in deliveriesByCity" :key="index" class="px-0">
                  <div class="d-flex justify-space-between grey lighten-4 w-100 mb-1 pr-2">
                    <div class="d-flex">
                      <v-icon :color="cityColors[index % cityColors.length]" size="20"> mdi-circle-medium </v-icon>
                      <span class="font-weight-medium">{{ item.cityName }}</span>
                    </div>
                    <span class="font-weight-bold primary--text">{{
                      nfesByCity ? item.nfesQuantity : item.ctesQuantity
                    }}</span>
                  </div>
                </v-list-item>
              </v-list>
            </div>
          </div>
        </v-card>
      </v-col>
      <v-col cols="12" md sm="6">
        <v-card class="px-1">
          <div class="d-flex" style="height: 30px">
            <h1 class="title-area text-left black--text font-weight-medium" style="width: 205px">
              Entregas por embarcador
            </h1>
            <v-radio-group v-model="nfesByTranshipment" row mandatory>
              <v-radio label="NFes" :value="true" class="small-radio"></v-radio>
              <v-radio label="Entregas" :value="false" class="small-radio"></v-radio>
            </v-radio-group>
          </div>
          <div class="d-flex justify-center pt-8" style="height: 240px; margin: auto; flex-grow: 1">
            <v-progress-circular v-if="loading" indeterminate color="primary" size="140"></v-progress-circular>

            <div class="d-flex pr-4 justify-end">
              <canvas
                id="secondDoughnutChart"
                style="max-width: 160px; max-height: 160px"
                :style="{ display: loading ? 'none' : '' }"
              ></canvas>
            </div>
            <div v-if="!loading" class="d-flex" style="height: 240px">
              <v-list class="pa-0 pr-2 deliveries-list scrollbar-list" style="">
                <v-list-item v-for="(item, index) in deliveriesBySender" :key="index" class="px-0">
                  <div class="d-flex justify-space-between grey lighten-4 w-100 mb-1 pr-2">
                    <div class="d-flex">
                      <v-icon :color="cityColors[index]" size="20">mdi-circle-medium</v-icon>
                      <TruncateDataWithTooltip
                        customClass="font-weight-medium"
                        :data="item.nameSender"
                        :lengthDataToTruncate="18"
                      ></TruncateDataWithTooltip>
                    </div>
                    <span class="value font-weight-bold primary--text">{{
                      nfesByTranshipment ? item.nfesQuantity : item.ctesQuantity
                    }}</span>
                  </div>
                </v-list-item>
              </v-list>
            </div>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </v-card-text>
</template>

<script>
import TruncateDataWithTooltip from '@/components/Table/TruncateDataWithTooltip.vue';
import { Chart, registerables } from 'chart.js';
import { mapActions } from 'vuex';
import maskPrice from '@/utils/maskPrice';
Chart.register(...registerables);

export default {
  name: 'ConfirmationStep',
  components: { TruncateDataWithTooltip },
  props: {
    boardings: {
      type: Array,
      default: () => []
    },
    isConfirmationStep: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    loading: false,
    isLoadingDeliveriesBySender: false,
    nfesByCity: true,
    nfesByTranshipment: true,
    deliveriesByCity: [],
    deliveriesBySender: [],
    cityColors: [
      '#FF6384',
      '#36A2EB',
      '#FFCE56',
      '#4BC0C0',
      '#9966FF',
      '#FF9F40',
      '#FF6384',
      '#36A2EB',
      '#FFCE56',
      '#4BC0C0',
      '#9966FF',
      '#FF9F40'
    ]
  }),

  mounted() {
    this.fetchNfesAndDeliveriesByCityAndSender();
  },

  watch: {
    nfesByCity() {
      this.createDoughnutChart('doughnutChart', this.deliveriesByCity);
    },
    nfesByTranshipment() {
      this.createDoughnutChart('secondDoughnutChart', this.deliveriesBySender);
    }
  },
  computed: {
    parameterID() {
      return this.$route.params.id;
    }
  },
  methods: {
    ...mapActions('ImportManualDashboardStore', ['fetchQuantitiesNfesAndDeliveriesByCityAndSender']),

    async fetchNfesAndDeliveriesByCityAndSender() {
      this.loading = true;
      try {
        const data = await this.fetchQuantitiesNfesAndDeliveriesByCityAndSender(this.parameterID);
        this.deliveriesByCity = data.quantitiesNfesAndDeliveriesByCity;
        this.deliveriesBySender = data.quantitiesNfesAndDeliveriesBySender;

        setTimeout(() => {
          this.createDoughnutChart('doughnutChart', this.deliveriesByCity);
          this.createDoughnutChart('secondDoughnutChart', this.deliveriesBySender);
        }, 0);
      } catch (err) {
        console.error(err);
      } finally {
        this.loading = false;
      }
    },
    createDoughnutChart(chartId, dataList) {
      const canvas = document.getElementById(chartId);
      const ctx = canvas.getContext('2d');
      const labels = dataList.map((item) => (chartId === 'doughnutChart' ? item.cityName : item.nameSender));
      const dataValues = dataList.map((item) =>
        chartId === 'doughnutChart'
          ? this.nfesByCity
            ? item.nfesQuantity
            : item.ctesQuantity
          : this.nfesByTranshipment
          ? item.nfesQuantity
          : item.ctesQuantity
      );
      const total = dataValues.reduce((sum, currentValue) => sum + currentValue, 0);

      const centerTextPlugin = {
        id: 'centerText',
        beforeDraw(chart) {
          const { width, height, ctx } = chart;
          ctx.restore();

          const fontSize = (height / 150).toFixed(2);
          const firstLineFont = `${fontSize}em sans-serif`;
          const secondLineFont = `bolder ${1.3}em sans-serif`;
          ctx.textBaseline = 'middle';

          const firstLine = 'Total';
          const secondLine = total;

          ctx.font = firstLineFont;
          const firstLineTextX = Math.round((width - ctx.measureText(firstLine).width) / 2);
          const textYFirstLine = height / 2 - 10;
          ctx.fillText(firstLine, firstLineTextX, textYFirstLine);
          ctx.font = secondLineFont;
          const secondLineTextX = Math.round((width - ctx.measureText(secondLine).width) / 2);
          const textYSecondLine = height / 2 + 10;
          ctx.fillText(secondLine, secondLineTextX, textYSecondLine);

          ctx.save();
        }
      };

      if (ctx.chart) {
        ctx.chart.destroy();
      }

      ctx.chart = new Chart(ctx, {
        type: 'doughnut',
        data: {
          labels: labels,
          datasets: [
            {
              data: dataValues,
              backgroundColor: this.cityColors
            }
          ]
        },
        options: {
          responsive: true,
          plugins: {
            legend: {
              display: false
            },
            tooltip: {
              callbacks: {
                label: (tooltipItem) => {
                  const name = labels[tooltipItem.dataIndex];
                  const value = dataValues[tooltipItem.dataIndex];
                  return `${name}: ${value}${
                    chartId === 'doughnutChart'
                      ? this.nfesByCity
                        ? ' NFes'
                        : ' Entregas'
                      : this.nfesByTranshipment
                      ? ' NFes'
                      : ' Entregas'
                  }`;
                }
              }
            }
          }
        },
        plugins: [centerTextPlugin]
      });
    },
    tableBoardingsHeight() {
      const hasMoreThanFiveBoarding = this.boardings.length > 3;
      return hasMoreThanFiveBoarding ? '210' : '';
    },

    formatPrice(price) {
      return maskPrice(price);
    }
  }
};
</script>
<style lang="scss" scoped>
.bg-azul {
  background: #1f77b4;
  width: 100%;
  flex-wrap: wrap;
  display: flex;
  height: 80px;
  border-radius: 5px;
  justify-content: center;
  align-items: center;
}
.title-area {
  padding-left: 10px;
  padding-top: 8px;
  font-size: 16px;
  width: 100%;
  color: #ffffff;
  font-weight: bolder;
}
.text-area {
  padding-left: 10px;
  margin-bottom: 6px;
  font-size: 32px;
  font-weight: bold;
  color: #ffffff;
  text-align: left;
}
.text-percentage {
  font-size: 52px;
  line-height: 52px;
  height: 52px;
  font-weight: bold;
}
.info-card {
  height: 288px;
  width: 530px;
}
.deliveries-list {
  width: 250px;
  height: 160px;
  overflow-y: auto;
}
.scrollbar-list::-webkit-scrollbar {
  width: 8px;
  height: 5px;
  background-color: #f5f5f5;
}
.scrollbar-list::-webkit-scrollbar-track {
  padding-left: 1px;
  padding-right: 1px;
  background-color: #f5f5f5;
}
.scrollbar-list::-webkit-scrollbar-thumb {
  background-color: #999999;
  border-radius: 8px;
}
.scrollbar-list::-webkit-scrollbar-thumb:hover {
  background-color: #0f426e9d;
}

::v-deep .v-list-item {
  min-height: 24px;
}
::v-deep .table-shipping-cost.v-data-table.v-data-table--fixed-header thead th {
  background-color: #e0e0e0 !important;
  border: 1px solid #e0e0e0;
  z-index: auto;
}
::v-deep .table-shipping-cost.v-data-table.v-data-table--fixed-header th {
  padding: 5px 10px 5px 2px;
  font-size: 12px;
}
::v-deep .table-shipping-cost.v-data-table.v-data-table--fixed-header td {
  padding: 0px 8px 3px 0px;
  height: 35px;
  font-size: 11px;
}
::v-deep .table-shipping-cost .v-data-table__wrapper::-webkit-scrollbar {
  width: 8px;
  height: 5px;
  background-color: #f5f5f5;
}
::v-deep .table-shipping-cost .v-data-table__wrapper::-webkit-scrollbar-thumb {
  background-color: #999999;
  border-radius: 8px;
}
::v-deep .table-shipping-cost .v-data-table__wrapper::-webkit-scrollbar-thumb:hover {
  background-color: #0f426e9d;
}
</style>
